import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import vuex from './store';
import moment from 'moment';
// 解决在使用element-ui时出现警告[Violation] Added non-passive event listener to a scroll-blocking ‘mousewheel’ event.
// Consider marking event handler as ‘passive’ to make the page more responsive。
// import 'default-passive-events'
//解决end

// #element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 所有的插件扩展
import Myplugin from './plugins'
Vue.use(Myplugin)

import  {VueJsonp}  from  'vue-jsonp'
Vue.use(VueJsonp)

//hyj
import './assets/css/h_public.css'
import './assets/css/hStyle.scss'
import 'font-awesome/css/font-awesome.min.css'


Vue.config.productionTip = false

import auth from './utils/auth'
const whiteList = ['/login','/ssoLogin', '/sign','/account_complaint','/resetPass','/resetPassPage','/resetPassSave','/firstlogin','/twoLogin','/lq_riqingpingjia','/lq_riqingReport','/lq_muBiaoMonth','/lq_muBiaoWeek','/lq_dakajilu','/singleLogin','/cluesLogin'];// 不重定向白名单
const whiteListLogin = ['/firstPage','/secondPage', '/thirdPage','/fourthPage','/'];// 不重定向白名单
router.beforeEach((to, from, next) => {
    try {
        if (auth.getToken()) { // 判断是否有token
            if (to.path === '/login') {
                next({ path: '/' });
            } else {
                if (store.getters.loginflag && store.getters.dicts) { // 判断当前用户是否已拉取完user_info信息
                    // if (whiteList.indexOf(to.path) === -1 && store.getters.menulist.indexOf(to.path) === -1 && whiteListLogin.indexOf(to.path) === -1) { // 在免登录白名单，直接进入
                    //     next();
                    //     // alert("无访问权限！");
                    //     // next('/login'); // 否则全部重定向到登录页
                    // } else{
                    //     next();
                    // }
                    if (to.meta.isTabsPage) {
                        const tabsItem = {
                            name: to.name,
                            title: to.meta.title,
                            path: to.path
                        }
                        vuex.commit('addTabsValue', tabsItem)
                    }
                    next();
                } else {
                    Promise.all(
                        [store.dispatch('getNowUser'),
                        store.dispatch('getAllDictList')]).then(() => {
                        // if (whiteList.indexOf(to.path) === -1 && store.getters.menulist.indexOf(to.path) === -1 && whiteListLogin.indexOf(to.path) === -1) { // 在免登录白名单，直接进入
                        //     next();
                        //     // alert("无访问权限！");
                        //     // next('/login'); // 否则全部重定向到登录页
                        // } else{
                        //     next();
                        // }
                        next();
                    })
                }
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
                next()
            } else {
                next('/login'); // 否则全部重定向到登录页
            }
        }
    }catch (e) {
        alert("搞不到改地址，请联系管理员！");
    }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$moment = moment;//赋值使用
